var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonePrevencherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.916 17.474c-2.039 0-4.026-.454-5.962-1.363a18.076 18.076 0 0 1-5.143-3.603 18.078 18.078 0 0 1-3.603-5.144C1.299 5.43.845 3.441.845 1.403c0-.284.095-.522.284-.711A.965.965 0 0 1 1.84.407h3.84a.91.91 0 0 1 .593.214.834.834 0 0 1 .308.545l.616 3.318c.032.222.028.423-.012.605a.97.97 0 0 1-.272.486l-2.3 2.323a15.538 15.538 0 0 0 2.501 3.2 17.675 17.675 0 0 0 3.307 2.583l2.228-2.228c.142-.142.328-.249.557-.32.23-.07.455-.09.676-.059l3.27.664a.963.963 0 0 1 .546.32c.142.166.213.36.213.58v3.84a.964.964 0 0 1-.284.712.964.964 0 0 1-.711.284ZM3.713 6.096l1.564-1.564-.403-2.228h-2.11c.08.648.19 1.288.333 1.92.142.632.347 1.256.616 1.872Zm8.486 8.486a11.762 11.762 0 0 0 3.816.948v-2.086l-2.228-.45-1.588 1.588Z",
    fill: "#2F42C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePrevencherIcon);
export default __webpack_public_path__ + "static/media/phone_prevencher_icon.775876eee920284039d00a98672549bf.svg";
export { ForwardRef as ReactComponent };